import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/misc/graphic-element-1.png'
import _imports_1 from '@/assets/misc/graphic-element-2.png'


const _withScopeId = n => (_pushScopeId("data-v-3c764d47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container-lg p-0 p-lg-auto" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-uppercase m-0 mb-3 text-center text-sm-start" }, [
  /*#__PURE__*/_createTextVNode("Simple Living "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-none d-md-block" }),
  /*#__PURE__*/_createTextVNode("that Lasts")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h3 text-uppercase text-primary mb-4 mb-xl-5 text-center text-sm-start" }, "Distinguish your Home", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4 mb-xl-5 col-md-11 text-center text-sm-start" }, "We believe in keeping things simple. We believe that time is precious. We believe in longevity for people and product. We believe in being outstanding.", -1))
const _hoisted_7 = { class: "d-flex justify-content-center justify-content-sm-start" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-secondary px-4 px-lg-5 py-2 py-lg-3 mb-2" }, "Read More", -1))
const _hoisted_9 = { class: "container p-0 p-sm-auto" }
const _hoisted_10 = { class: "container p-0 p-sm-auto position-relative" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "graphic-element-1 position-absolute",
  src: _imports_0,
  alt: "Berkart Floral Graphic Element"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "graphic-element-2 position-absolute",
  src: _imports_1,
  alt: "Berkart Floral Graphic Element"
}, null, -1))
const _hoisted_13 = { class: "container p-0 p-sm-auto" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-centered mt-4 mt-md-5" }, [
  /*#__PURE__*/_createElementVNode("hr", {
    class: "col-5 col-md-3 text-primary",
    style: {"opacity":"1","border-top-width":"2px"}
  })
], -1))
const _hoisted_15 = { class: "container p-0 p-sm-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarouselBanner = _resolveComponent("CarouselBanner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InfoSection = _resolveComponent("InfoSection")!
  const _component_GenericBanner = _resolveComponent("GenericBanner")!
  const _component_RegisterWarrantyBanner = _resolveComponent("RegisterWarrantyBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CarouselBanner, {
        uniqueId: "homeBanner",
        images: _ctx.homeBannerImages
      }, null, 8, ["images"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InfoSection, {
        class: "my-5",
        imageSrc: _ctx.introSection.imageSrc,
        imageAlt: _ctx.introSection.imageAlt,
        imageLocation: _ctx.introSection.imageLocation,
        hideImageMobile: true
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "text-decoration-none",
              to: { name: 'AboutUs' }
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["imageSrc", "imageAlt", "imageLocation"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_GenericBanner, {
        image: _ctx.genericBanners.smallKitchenAppliances
      }, null, 8, ["image"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_GenericBanner, {
        image: _ctx.genericBanners.smallHouseholdAppliances
      }, null, 8, ["image"]),
      _hoisted_11,
      _hoisted_12
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_GenericBanner, {
        image: _ctx.genericBanners.floorcare
      }, null, 8, ["image"])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_RegisterWarrantyBanner, { showBg: false })
    ])
  ]))
}